import { l } from '@manychat/manyui'

import {
  AttachmentBlockAttachmentPlaceholder,
  AttachmentBlockAttachmentType,
  getAttachmentIcon,
} from 'common/builder/blocks/blockConstants'
import { IAttachmentBlock, IBlock } from 'common/builder/blocks/blockInterfaces'
import {
  BlockConverterRulePayload,
  ConverterRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { getButtonsFromMap } from 'common/builder/components/chart/FlowChart/lib/utils/getButtonsFromMap'
import { replaceFieldsInString } from 'common/builder/components/chart/FlowChart/lib/utils/replaceFieldsInString'
import { AttachmentAppearance } from 'common/builder/components/chart/FlowChart/types/AttachmentAppearance'
import { FlowChartAttachmentBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartAttachmentBlock'
import { FlowChartBlockType } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'
import { BlockType } from 'common/builder/constants/BlockType'

export const AttachmentBlockGenericConverterRule: ConverterRule<
  IAttachmentBlock,
  FlowChartAttachmentBlock,
  BlockConverterRulePayload
> = {
  predicate: (entity: IBlock) => entity?.type === BlockType.ATTACHMENT,
  convert: (entity: IAttachmentBlock, { fields, flowChartButtons }) => {
    let appearance: AttachmentAppearance = AttachmentAppearance.PLACEHOLDER

    let title = l.getString(
      AttachmentBlockAttachmentPlaceholder[
        entity.attachmentType || AttachmentBlockAttachmentType.FILE
      ],
    )

    const isEmpty =
      !entity.attachment || !entity.attachment?.type || !Object.keys(entity.attachment).length

    if (!isEmpty && entity.attachment?.type === AttachmentBlockAttachmentType.EXTERNAL_IMAGE) {
      title = replaceFieldsInString(entity.attachment.image_url, fields)
      appearance = AttachmentAppearance.EXTERNAL
    } else if (!isEmpty) {
      title = entity.attachment && 'title' in entity.attachment ? entity.attachment.title : ''
      appearance = AttachmentAppearance.DEFAULT
    }

    return {
      id: entity.id,
      type: FlowChartBlockType.ATTACHMENT,
      data: {
        attachment: {
          appearance,
          title,
          icon: getAttachmentIcon(entity),
        },
        buttons: isEmpty ? [] : getButtonsFromMap(entity.buttons, flowChartButtons),
      },
    }
  },
}
